import Naluri from '~/common/api/naluri';
import {
  NEW_PROFILE_GET_FIRST_STEPS_BEGIN,
  NEW_PROFILE_GET_FIRST_STEPS_SUCCESS,
  NEW_PROFILE_GET_FIRST_STEPS_FAILURE,
} from './constants';

export function getFirstSteps(userID) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: NEW_PROFILE_GET_FIRST_STEPS_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = Naluri.get(`/api/expert/users/${userID}/first-steps`);
      doRequest.then(
        res => {
          dispatch({
            type: NEW_PROFILE_GET_FIRST_STEPS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: NEW_PROFILE_GET_FIRST_STEPS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case NEW_PROFILE_GET_FIRST_STEPS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        isFetchingFirstSteps: true,
        errorFirstSteps:      null,
      };

    case NEW_PROFILE_GET_FIRST_STEPS_SUCCESS:
      // The request is success
      return {
        ...state,
        isFetchingFirstSteps: false,
        errorFirstSteps:      null,
        banners:              action.data.user_banners,
      };

    case NEW_PROFILE_GET_FIRST_STEPS_FAILURE:
      // The request is failed
      return {
        ...state,
        isFetchingFirstSteps: false,
        errorFirstSteps:      action.data.error,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/new-profile/redux/getFirstSteps.js